import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH } from '../constants';
import { getSearchQuery } from '../selectors';
import { getBrowseDeviationStreamId } from '../helpers';
function* handleInitBrowseDeviationStream() {
    const searchQuery = yield select(getSearchQuery);
    const streamId = getBrowseDeviationStreamId(searchQuery);
    const isStreamInitialized = yield select(selectors.isInitialized, streamId);
    if (isStreamInitialized && !searchQuery) {
        return;
    }
    yield all([
        put(withOffset.actions.initialize({
            streamId,
            itemsPerFetch: DEVIATIONS_PER_FETCH
        })),
        put(withOffset.actions.fetch(streamId))
    ]);
}
export default handleInitBrowseDeviationStream;

//# sourceMappingURL=initBrowseStream.js.map